import type * as schema from './schema';
import restClient, { ApiError } from './RestClient';
import { RunTaskEntity } from './entities/replancity_RunTask';

export type RunStorageFile = {
    filePath: string;
    name: string;
    size: number;
    type: string;
};

export const runApi = {
    getRuns: function ({
        projectId,
        abortSignal,
    }: {
        projectId: string;
        abortSignal: AbortSignal;
    }): Promise<schema.definitions['entities_replancity_RunTask'][]> {
        return restClient.fetch({
            method: 'GET',
            path: 'queries/replancity_RunTask/runs',
            data: { projectId },
            fetchOptions: { signal: abortSignal },
        });
    },

    getRunParams: function ({
        runId,
        abortSignal,
    }: {
        runId: string;
        abortSignal: AbortSignal;
    }): Promise<RunTaskEntity> {
        return restClient.fetch({
            method: 'GET',
            path: 'services/replancity_RunTaskService/getRunParams',
            data: { runId },
            fetchOptions: { signal: abortSignal },
        });
    },

    getRunFiles: function ({
        runId,
        abortSignal,
    }: {
        runId: string;
        abortSignal: AbortSignal;
    }): Promise<RunStorageFile[]> {
        return restClient.fetch({
            method: 'GET',
            path: 'services/replancity_RunTaskResultService/getRunStorageFiles',
            data: { runId },
            fetchOptions: { signal: abortSignal },
        });
    },

    getFileDownloadLink: function ({
        runId,
        filePath,
        abortSignal,
    }: {
        runId: string;
        filePath: string;
        abortSignal: AbortSignal;
    }): Promise<string | ApiError> {
        return restClient.fetch({
            method: 'GET',
            path: 'services/replancity_RunTaskResultService/generateDownloadLink',
            data: { runId, filePath },
            fetchOptions: { signal: abortSignal },
        });
    },
};
